<div class="value">
  <ng-content select=".val"></ng-content>
</div>
<div class="desc">
  <ng-content select=".heading"></ng-content>
</div>
